import { render, staticRenderFns } from "./navTabs.vue?vue&type=template&id=7339fe7a&scoped=true&"
import script from "./navTabs.vue?vue&type=script&lang=ts&"
export * from "./navTabs.vue?vue&type=script&lang=ts&"
import style0 from "./navTabs.vue?vue&type=style&index=0&id=7339fe7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7339fe7a",
  null
  
)

export default component.exports